export default {"src":"/_next/static/media/x4y-icon.d95f5e9b.svg","height":25,"width":25};